import { Controller } from "stimulus";

export default class extends Controller {
  static values = { config: Object };

  replay() {
    if (!window.FxNoveltyTour) {
      console.warn("FxNoveltyTour engine not loaded");
      return;
    }
    if (this.hasConfigValue && Object.keys(this.configValue).length) {
      window.FxNoveltyTour.replay(this.configValue);
    }
  }
}
